import { useCallback, useEffect, useState } from "react";

import { useGlobalContext } from "../Context/GlobalContext";

export const useDeliveryInstructions = (taskId) => {
  const { packkyApi } = useGlobalContext();

  const [instructionList, setInstructionList] = useState([]);
  const [submittedInstruction, setSubmittedInstruction] = useState(null);
  const [existingInstruction, setExistingInstruction] = useState(null);

  // =====================================================
  // GET DELIVERY INSTRUCTION LIST
  // =====================================================

  const fetchInstructions = useCallback(async () => {
    try {
      const payload = {
        status: "Y",
      };

      const res = await packkyApi.post(
        "/api/DriverTracker/v1.0/getDeliveryInstructions",
        payload,
      );

      if (res?.data?.responseCode === "00") {
        setInstructionList(res?.data?.data || []);
      } else {
        setInstructionList([]);
      }

      return res?.data;
    } catch (error) {
      console.error("GET DELIVERY INSTRUCTIONS ERROR:", error);

      setInstructionList([]);

      return null;
    }
  }, [packkyApi]);

  // =====================================================
  // GET CUSTOMER DELIVERY INSTRUCTION
  // =====================================================

  const fetchCustomerInstruction = useCallback(async () => {
    if (!taskId) {
      setExistingInstruction(null);
      return null;
    }

    try {
      const payload = {
        taskId: String(taskId),
      };

      const res = await packkyApi.post(
        "/api/DriverTracker/v1.0/getCustomerDeliveryInstructions",
        payload,
      );

      if (res?.data?.responseCode === "00") {
        setExistingInstruction(res?.data?.data?.[0] || null);
      } else {
        setExistingInstruction(null);
      }

      return res?.data;
    } catch (error) {
      console.error("GET CUSTOMER DELIVERY INSTRUCTION ERROR:", error);

      setExistingInstruction(null);

      return null;
    }
  }, [packkyApi, taskId]);

  // =====================================================
  // INSERT CUSTOMER DELIVERY INSTRUCTION
  // =====================================================

  const submitInstruction = useCallback(
    async (payload) => {
      try {
        const res = await packkyApi.post(
          "/api/DriverTracker/v1.0/insertCustomerDeliveryInstructions",
          payload,
        );

        if (res?.data?.responseCode !== "00") {
          throw new Error(
            res?.data?.responseMessage || "Instruction submit nahi ho payi.",
          );
        }

        setSubmittedInstruction({
          title:
            instructionList.find(
              (item) => item?.pk_instruction_id === payload?.instructionId,
            )?.title || "Custom instruction",

          customerMessage: payload?.extraMessege || "",
        });

        await fetchCustomerInstruction();

        return res?.data;
      } catch (error) {
        console.error("INSERT DELIVERY INSTRUCTION ERROR:", error);

        return null;
      }
    },
    [packkyApi, instructionList, fetchCustomerInstruction],
  );

  // =====================================================
  // FETCH EXISTING INSTRUCTION WHEN TASK CHANGES
  // =====================================================

  useEffect(() => {
    if (!taskId) {
      setExistingInstruction(null);
      return;
    }

    fetchCustomerInstruction();
  }, [taskId, fetchCustomerInstruction]);

  // =====================================================
  // RETURN
  // =====================================================

  return {
    instructionList,
    submittedInstruction,
    existingInstruction,

    fetchInstructions,
    fetchCustomerInstruction,
    submitInstruction,
  };
};
